import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreCustomersCurrentFeatureFlagsGetAsyncSlice } from './get';

export const coreCustomersCurrentFeatureFlagsReducers = combineReducers({
	get: coreCustomersCurrentFeatureFlagsGetAsyncSlice.asyncReducers
});

export const coreCustomersCurrentFeatureFlagsWatchers = combineAllWatchers([
	coreCustomersCurrentFeatureFlagsGetAsyncSlice.asyncWatchers
]);
